import { createStore } from 'vuex'

export default createStore({
  state: {
    user: {
      isLogin: false
    }
  },
  getters: {
  },
  mutations: {
    setIslogin(state, payload) {
      state.user.isLogin = payload;
    }
  },
  actions: {
  },
  modules: {
  }
})
